class ProductStitcher extends HTMLElement {
  constructor() {
      super();

      this.selectors = {
          productInfo: "[js-hb-main-product]",
          productReviews: "[js-product-review]",
          sizeGuide: "[js-size-guide]",
          stitcherItem: "[js-stitcher-item]"
      };
    
      this.sections = {
      
          mainProduct: { 
              element: document.querySelector(this.selectors.productInfo), 
              selector: this.selectors.productInfo, 
              initEvents: ["size-guide:init", "mainProductSectionMarquee:init"] 
          },
           productReviews: { 
               element: document.querySelector(this.selectors.productReviews), 
               selector: this.selectors.productReviews 
           },
           sizeGuide: { 
               element: document.querySelector(this.selectors.sizeGuide), 
               selector: this.selectors.sizeGuide,
               initEvents: ["size-guide:init", "optiscroll:init"] 
           }
      };

      this.stitcherItems = this.querySelectorAll(this.selectors.stitcherItem);

      this.init();
  }

  init() {
      this.stitcherItems.forEach(stitcherItem =>
          stitcherItem.addEventListener("click", this.renderSectionFromFetch.bind(this))
      );
  }

  renderSectionFromFetch(evt) {
     
      evt.preventDefault();
      const { currentTarget } = evt;
      const handle = currentTarget.getAttribute("data-product-handle");

      this.updateLoading();
      Object.values(this.sections).forEach(({ element, selector, initEvents = [] }) => {
        
          element && this.renderSection(handle, element, selector, ...initEvents);
      });
  }

  updateLoading() {
      this.sections.mainProduct.element.classList.add("section--loading");
  }

  renderSection(handle, container, selector, ...initEvents) {
      const url = `/products/${handle}?section_id=${container.getAttribute("data-section")}`;
      this.ajaxSection(url, container, selector, handle, initEvents);
  }

  ajaxSection(url, container, selector, handle, initEvents = []) {
      fetch(url)
          .then(response => response.text())
          
          .then(html => {
              const ajaxContainer = new DOMParser()
                  .parseFromString(html, 'text/html')
                  .querySelector(selector);
              if (ajaxContainer) {
                  selector === this.selectors.productInfo 
                  ? container.outerHTML = ajaxContainer.outerHTML
                  : container.innerHTML = ajaxContainer.innerHTML
              }

              if(selector === this.selectors.productInfo) { 
                  window.Shopify.theme.sections.registered.product(document.querySelector('[data-section-type="product"]'));
              }

              initEvents.forEach(eventName => document.dispatchEvent(new CustomEvent(eventName)));
              selector === this.selectors.objectTableColumn || selector === this.selectors.sizeGuide ||  selector === this.selectors.objectImageWithText || selector === this.selectors.objectOverlayItem ;
              selector === this.selectors.productReviews ? yotpo.initWidgets() : null;
              selector === this.selectors.productInfo ? yotpo.initWidgets() : null;
          })
          .catch(err => {
              console.log(err)
          })
  }
}

customElements.define('product-stitcher', ProductStitcher);